export const filterFieldDefinitions = (fieldDefinitions = []) => {
  return fieldDefinitions.filter((field = {}) => {
    let isVisible = true;
    const dependFieldDefinitionName = field.depend_field_definition;
    const dependFieldValue = field.depend_field_value;

    if (dependFieldDefinitionName && dependFieldValue) {
      const dependFieldDefinition = fieldDefinitions.find(
        (definition = {}) => definition.slug === dependFieldDefinitionName
      );
      if (dependFieldDefinition) {
        isVisible = dependFieldDefinition.field_value === dependFieldValue;
      }
    }
    return isVisible;
  });
};
